// Modules
import Common from "./modules/common";
import Header from "./modules/header";
import Lightbox from "./modules/lightbox";
import ProModal from "./modules/pro-modal";
import WooCommon from "./modules/woo-common";
import QuickCart from "./modules/quick-cart";
import YouTube from "./modules/youtube";
import ProductReturn from "./partials/product-return";

// Autoload modules
const modules = [Common, Header, Lightbox, ProModal, WooCommon, QuickCart, YouTube, ProductReturn];

modules.forEach((module) => {
  module.init();
});

// import local dependencies
import Router from "./utils/router";
import templateHome from "./partials/home";
import templateContacts from "./partials/contacts";
import templateBrand from "./partials/brand";
import templateSale from "./partials/sale";
import templateNews from "./partials/news";
import templateBusiness from "./partials/business";
import taxProductCat from "./partials/product-archive";
import singlePost from "./partials/single";
import singleProduct from "./partials/single-product";
import woocommerceAccount from "./partials/woo-account";
import woocommerceCart from "./partials/woo-cart";
import woocommerceCheckout from "./partials/woo-checkout";

// Populate Router instance with DOM routes
const routes = new Router({
  templateHome,
  templateContacts,
  templateBrand,
  templateSale,
  templateNews,
  templateBusiness,
  taxCategory: templateNews,
  taxProductCat,
  singlePost,
  singleProduct,
  woocommerceAccount,
  woocommerceCart,
  woocommerceCheckout,
});

// Load Events
$(document).ready(() => routes.loadEvents());
